













































































































































































import { Component, mixins } from 'nuxt-property-decorator'
import { NuxtAppOptions } from '@nuxt/types'
import LazyHydrate from 'vue-lazy-hydration'
import MixinPage from '~/assets/mixins/page'
import { INDEX_API } from '~/assets/config/api-path'
import {
  IPageIndexContentActions,
  IPageIndexContentArticles,
  IPageIndexContentBanners,
  IPageIndexContentBrands,
  IPageIndexContentCategories,
  IPageIndexContentCollections,
  IPageIndexContentProductDay,
  IPageIndexContentProducts,
  IPageIndexContentSlider,
  IPageIndexContentStories,
  IPageIndexContentText,
  IPageIndexContentVideo,
} from '~/assets/interfaces/page'
import ComponentPageContent from '~/components/pages/content.vue'
import { IStyle } from '~/assets/interfaces/classes'
import MixinGeneral from '~/assets/mixins/general'
import { runIdle } from '~/assets/functions/runIndle'
import 'swiper/swiper.scss' // Для слайдеров. Чтобы не скакали

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageIndexArticlesContent: () =>
      import('~/components/pages/index/page-index-articles-content.vue'),
    ComponentPageIndexBrandsContent: () =>
      import('~/components/pages/index/page-index-brands-content.vue'),
    ComponentPageIndexActionsContent: () =>
      import('~/components/pages/index/page-index-actions-content.vue'),
    ComponentPageIndexCollectionsContent: () =>
      import('~/components/pages/index/page-index-collections-content.vue'),
    ComponentPageIndexVideoContent: () =>
      import('~/components/pages/index/page-index-video-content.vue'),
    ComponentPageIndexProducts: () =>
      import('~/components/pages/index/page-index-products.vue'),
    ComponentPageIndexCategoriesContent: () =>
      import('~/components/pages/index/page-index-categories-content.vue'),
    ComponentPageIndexBannersContent: () =>
      import('~/components/pages/index/page-index-banners-content.vue'),
    ComponentPageIndexStories: () =>
      import('~/components/pages/index/page-index-stories.vue'),
    ComponentMobileSearch: () =>
      import('~/components/mobile/search/search.vue'),
    ComponentProductDayItems: () =>
      import('~/components/products/product-day-items.vue'),
    ComponentSliderStandard: () => import('~/components/slider/standard.vue'),
    ComponentPageContent,
    LazyHydrate,
  },
})
export default class pageIndex extends mixins(MixinPage, MixinGeneral) {
  async asyncData({ $axios }: { $axios: NuxtAppOptions['$axios'] }) {
    const response = await $axios.$get(INDEX_API)

    return response
  }

  styleGrid!: IStyle
  styleSpacer!: IStyle

  isMounted = false

  actions: IPageIndexContentActions | null = null
  articles: IPageIndexContentArticles | null = null
  banners: IPageIndexContentBanners | null = null
  brands: IPageIndexContentBrands | null = null
  categories: IPageIndexContentCategories | null = null
  collections: IPageIndexContentCollections | null = null
  productDay: IPageIndexContentProductDay | null = null
  products: IPageIndexContentProducts | null = null
  slider: IPageIndexContentSlider | null = null
  stories: IPageIndexContentStories | null = null
  text: IPageIndexContentText | null = null
  video: IPageIndexContentVideo | null = null
  lcp: string | null = null

  get sliderShow() {
    return this.slider && this.slider.items.length > 0
  }

  get productDayShow() {
    return this.productDay && this.productDay.items.length > 0
  }

  get productDayShowDesktop() {
    return (
      !this.isMobile && this.productDayShow && this.slider?.type !== 'type-2'
    )
  }

  get isShowBannersBlock1() {
    return this.banners && this.banners.block1.length > 0
  }

  get isShowBannersBlock2() {
    return this.banners && this.banners.block2.length > 0
  }

  get isShowBannersBlock3() {
    return this.banners && this.banners.block3.length > 0
  }

  get isShowBannersBlock4() {
    return this.banners && this.banners.block4.length > 0
  }

  get isShowProductsBlock1() {
    return this.products && this.products.block1.length > 0
  }

  get isShowProductsBlock2() {
    return this.products && this.products.block2.length > 0
  }

  get isShowProductsBlock3() {
    return this.products && this.products.block3.length > 0
  }

  get isShowProductsBlock4() {
    return this.products && this.products.block4.length > 0
  }

  get isShowStories() {
    return this.stories && this.stories.items.length > 0
  }

  get isShowCategories() {
    return this.categories && this.categories.items.length > 0
  }

  get isShowVideos() {
    return this.video && this.video.items.length > 0
  }

  get isShowCollections() {
    return this.collections && this.collections.items.length > 0
  }

  get isShowActions() {
    return this.actions && this.actions.items.length > 0
  }

  get isShowBrands() {
    return this.brands && this.brands.items.length > 0
  }

  get isShowArticles() {
    return this.articles && this.articles.items.length > 0
  }

  get isShowText() {
    return this.text && this.text.text
  }

  get products3Banners4ProductsColumnCount() {
    return this.isShowBannersBlock4 ? 4 : 5
  }

  get classSliderWrapper() {
    const base = [this.styleSpacer.mbGutter]
    if (!this.isMobile) {
      base.push(this.styleGrid.grid)
    }
    return base
  }

  get classSlider() {
    if (this.isMobile) {
      return ''
    } else {
      return this.productDayShowDesktop
        ? this.styleGrid.col9
        : this.styleGrid.col12
    }
  }

  get classProducts3Banners4Products() {
    return this.isShowBannersBlock4 && !this.isMobile
      ? this.styleGrid.col9
      : this.styleGrid.col12
  }

  get classProducts3Banners4Banners() {
    return this.isMobile ? this.styleGrid.col12 : this.styleGrid.col3
  }

  created() {
    this.initMeta()
  }

  mounted() {
    runIdle(() => {
      this.isMounted = true
    })
  }

  head() {
    const links = []

    if (this.lcp) {
      links.push({
        rel: 'preload',
        as: 'image',
        fetchpriority: 'high',
        href: this.lcp,
      })
    }

    return {
      link: links,
    }
  }
}
